import { ConceptValueDataType } from '@fusion-advantage/backcompat'
import { PrescriptionHistoryConcept } from "@fusion-advantage/formlib"
import { useFormSelector } from "../../../redux/formStoreHooks"
import L3HistoricalMedicationsTable from "../l3/L3HistoricalMedicationsTable"
import { useConceptValidator } from "./useConceptValidator"
import { useCallback, useContext, useEffect } from "react"
import L6FormContext from "../l6/L6FormContext"

interface L4MedicationHistoryTableProps {
	xpath?: string
}

export const L4MedicationHistoryTable = ({xpath}: L4MedicationHistoryTableProps) => {
	const { errorNode } = useConceptValidator({
		tagName: 'L4TabularList',
		cid: PrescriptionHistoryConcept.cid,
		requireConcept: true,
		allowDataTypes: [ConceptValueDataType.Object],
	})
	const models = useFormSelector(state => state.drug.history)
	const { setXpathValuedDeterminer } = useContext(L6FormContext)
	const isValued = useCallback(() => {
		return models.length > 0
	}, [models])
	useEffect(() => {
		if(xpath) {
			setXpathValuedDeterminer(xpath, isValued)
			return () => {
				setXpathValuedDeterminer(xpath, false)
			}
		}
	}, [xpath, setXpathValuedDeterminer, isValued])
	if(errorNode) {
		return errorNode
	}
	return <L3HistoricalMedicationsTable models={models} />
}
